import React, { Component, useState, useEffect, useMemo } from 'react';
import { Drawer, Table } from  'antd'
const { Column } = Table
// import { Container } from './styles';

const HistoryTable = ({variantId, stockLocationId}) => {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  useEffect(() => {
    if(!variantId) return
    stockLocationId = stockLocationId || ""
    setLoading(true)
    const url = Biscraft.routes.api.stocks_path + "/log_history" +
      "?variant_id=" + variantId + "&stock_location_id=" + stockLocationId + "&token=" + Spree.api_key
    fetch(url)
      .then(response => response.json())
      .then(results => {
        console.log("results: ", results)
        setData(results);

      })
      .finally(() => setLoading(false) );

  }
  , [variantId, stockLocationId])

  const showHistoryItemDetails = (record) => {
    debugger;
  }

  const columns = [
    {
      title: '#',
      dataIndex: '',
      key: 'serial',
      render: (text, record, index) => ++index
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => {

      const url = `/stocks/document_redirect?document_type=${record.document_type}&document_id=${record.document_id}&variant_id=${variantId}`
      return <a href={url} target="_blank" onClick={() => showHistoryItemDetails(record)}>{text}</a>
      }
    },    
    {
      title: 'Reference',
      dataIndex: 'reference',
      key: 'reference',
    }, 
    {
      title: 'In',
      dataIndex: 'stock_in',
      key: 'stock_in',
    },
    {
      title: 'Out',
      dataIndex: 'stock_out',
      key: 'stock_out',
    },    
    {
      title: 'Balance',
      dataIndex: 'balance',
      key: 'balance',
    },
  ];

  return(
    <Table 
      dataSource={data}
      loading = {loading}
      columns = {columns}
      pagination={false}
    >
        
    </Table>
    
  
  )
}

export default class StockHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  
  render() {
    const { variant_name, variant_name_ar } = this.props.variantData;
    let title = [variant_name, variant_name_ar, this.props.locationData?.name].filter(Boolean).join('  ')
    return(
      <Drawer
        width={"80%"}
        placement="right"
        closable={true}
        onClose={ this.props.onClose }
        visible={this.props.showHistory}
        destroyOnClose = {true}
      >     
        <h6>{title}</h6>

            <HistoryTable
              variantId = {this.props.variantData?.variant_id}
              stockLocationId = {this.props.locationData?.id}
            />      
      </Drawer>


    )
  }
}
